import { Injectable } from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

  constructor(protected http: HttpClient) { }

  sendToken(apikey: string, recaptcha: string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
      headers = headers.append('accept', 'application/json'); 
      headers = headers.append('xApiKeyPublic', apikey);
    return this.http.post<any>(environment.urlApi + '/reserva/validar-token-captcha/'+ recaptcha, '' ,{headers});
    
  }
}
